<template>
    <auth-layout :isPlain="true" :progress="isSent ? 100 : 0" :isProgressBarHidden="true">
        <template v-if="isSent">
            <common-content-wrapper width="large">
                <common-page-header :heading="$t('pages.auth.forgot_password.heading.done')"></common-page-header>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-message type="success">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <p v-html="$t('pages.auth.forgot_password.sent_instructions', { email })"></p>
                </common-message>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-page-copy size="minor">
                    <p>{{ $t('pages.auth.forgot_password.check_spam') }}</p>
                </common-page-copy>
                <p class="forgot-password__footer-line">
                    <button type="button" class="forgot-password__text-action" :disabled="isResending" @click="resendEmail()">
                        {{ resendButtonLabel }}
                    </button>
                </p>
                <p v-if="isResent" class="forgot-password__footer-line">
                    {{ $t('pages.auth.forgot_password.resent_sent') }}
                </p>
                <p v-if="resendError" class="forgot-password__error">{{ resendError }}</p>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-button
                    :label="$t('pages.auth.forgot_password.back_to_login')"
                    :route="{ name: 'auth.login' }"
                    type="primary"
                    size="large"
                ></common-button>
            </common-content-wrapper>
        </template>

        <template v-else>
            <common-content-wrapper width="large">
                <common-page-header
                    :heading="$t('pages.auth.forgot_password.heading.initial')"
                    :content="$t('pages.auth.forgot_password.description')"
                ></common-page-header>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <forgot-password-form @sent="afterSent($event)"></forgot-password-form>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-page-copy size="minor">
                    <router-link :to="{ name: 'auth.login' }">
                        {{ $t('pages.auth.forgot_password.back_to_login') }}
                    </router-link>
                </common-page-copy>
            </common-content-wrapper>
        </template>
    </auth-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import AuthLayout from 'components/layouts/AuthLayout'
    import ForgotPasswordForm from 'components/forms/AuthForgotPasswordForm'
    import AuthAPI from 'api/AuthAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            AuthLayout,
            ForgotPasswordForm,
        },

        data() {
            return {
                email: null,
                isSent: false,
                isResending: false,
                isResent: false,
                resendError: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.auth.forgot_password.title')
            },

            resendButtonLabel() {
                if (this.isResending) {
                    return this.$t('pages.auth.forgot_password.resending')
                }

                return this.$t('pages.auth.forgot_password.resent_email')
            },
        },

        methods: {
            afterSent({ email }) {
                this.email = email
                this.isSent = true
                this.isResent = false
                this.resendError = null
            },

            resendEmail() {
                if (!this.email || this.isResending) return

                this.resendError = null
                this.isResent = false
                this.isResending = true

                AuthAPI.forgotPassword(this.email)
                    .then(() => {
                        this.isResent = true
                    })
                    .catch((error) => {
                        this.resendError =
                            error?.code === 'LimitExceededException'
                                ? this.$t('pages.auth.forgot_password.resent_limit')
                                : this.$t('pages.auth.forgot_password.resent_failed')
                    })
                    .finally(() => {
                        this.isResending = false
                    })
            },
        },

        mounted: function () {
            //THIS SHOULD BE REMOVED WHEN RESPONSIVE IS IMPLEMENTED
            document.body.className = 'mobile'
        },
        beforeDestroy: function () {
            //THIS SHOULD BE REMOVED WHEN RESPONSIVE IS IMPLEMENTED
            document.body.className = ''
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_functions.scss';
    @import 'styles/setup/_mixins.scss';

    .forgot-password__footer-line {
        margin: rem(10px) 0 0;
        color: $color--txt-base;
        font-size: rem($font-size--form);
        line-height: 1.5;
    }

    .forgot-password__text-action {
        padding: 0;
        color: $color--accent-1;
        background: none;
        border: 0;
        font-family: inherit;
        font-size: inherit;
        font-weight: 700;
        letter-spacing: $letter-spacing--loose;
        text-transform: uppercase;
        cursor: pointer;

        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            color: $color--accent-3;
        }

        &:disabled {
            opacity: $opacity--is-disabled;
            cursor: not-allowed;
        }
    }

    .forgot-password__error {
        margin: rem(8px) 0 0;
        color: $color--accent-4;
        font-size: rem($font-size--form);
        line-height: 1.4;
    }
</style>
